import { Injectable } from '@angular/core';
import { scaleLinear, interpolateHcl } from 'd3';
import { range  } from 'lodash';

@Injectable()
export class TrendsSubjectColorResolver {
    private readonly subjectColors = [
        '#4682b8', '#a5d22d', '#f5cc0a', '#fe8c01', '#6b9494', '#b97c46', '#84acd0', '#c2e173', '#f9dd5b', '#fe569d',
        '#feb356', '#9cb8b8', '#d0a884', '#fa8072', '#bdB76b', '#ee82ee', '#bc8f8f', '#d2691e', '#3cb371', '#7fffd4',
        '#7b68ee', '#dc143c', '#00bfff', '#556b2f', '#a52a2a', '#ffe4e1', '#8470ff', '#eee8aa', '#8b658b', '#654321',
        '#08457E', '#986960', '#CD5B45', '#B8860B', '#c7db8e', '#310062', '#BDB76B', '#556832', '#03C03C', '#E75480',
        '#E9967A', '#560319', '#2F4F4F', '#177245', '#918151', '#116062', '#423189', '#FF1493', '#00BFFF', '#1560BD',
        '#1E90FF', '#00008B'
    ];
    
    private readonly colorScaler = scaleLinear<string, string>()
    .domain(range(this.subjectColors.length))
    .interpolate(interpolateHcl)
    .range(this.subjectColors);

    public getColor(index: number) {
        return this.colorScaler(index);
    }
}